import * as query from "@arcgis/core/rest/query";
import Query from "@arcgis/core/rest/support/Query";
import FieldNames from "../defaults/FieldNames.json";
import GeneralService from './GeneralService';
import Request from './request';
import { getAppConfig, getAttributeServiceUrl, getNifcToken } from "../utils/ReduxHelper";


const CancelService = {
  getCancelReasons: function() {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const queryObject = new Query({
          where: "(OBJECTID IS NOT NULL)",
          outFields: "*",
          returnGeometry: false,
      });
  
      return query.executeQueryJSON(rootServiceUrl + "/" + config.cancelReasons[config.env].layerId, queryObject).then(results => {
        let reasons = [];
        if(results.features) {
          reasons = results.features.map((eaItem) => eaItem.attributes);
        } 
        return(reasons)
      });    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  addCanceledFeatureEntry: function (cancelObj) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const nifcToken = getNifcToken();
      const newCancelEntry = 
      {
        attributes: cancelObj
      }

      return new Promise((resolve, reject) => {
        let layerID = config.canceledFeatures[config.env].layerId;
        new Request().makeRequest({
          url: rootServiceUrl + "/" + layerID + "/addFeatures",
          method: 'post',
          data: {
              f: 'json',
              token: nifcToken,
              features: JSON.stringify([newCancelEntry])
          }
        }).then(
            resp => {
              resolve(resp)
            },
            error => {
              reject(error)
            }
        );
      });    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  updateCanceledFeatureEntry: function (cancelUpdateObj) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const nifcToken = getNifcToken();
      let cancelObj = {
        attributes: cancelUpdateObj
      };

      return new Promise((resolve, reject) => {
        new Request().makeRequest({
          url: rootServiceUrl + "/" + config.canceledFeatures[config.env].layerId + "/updateFeatures",
          method: 'post',
          data: {
              f: 'json',
              token: nifcToken,
              features: JSON.stringify([cancelObj])
          }
      }).then(
          resp => {
            resolve(resp);
          },
          error => {
            reject(error)
          }
      )
      });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  addUpdateMultipleCancelFeatureEntries: async function (
    cancelItems,
    isUpdate = false
  ) {
    try{
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const nifcToken = getNifcToken();
      let layerID = config.canceledFeatures[config.env].layerId;
      let allFinalResults = [];
      let cancelList = [];
      cancelItems.forEach((cancelObj) => 
      {
        const newCancelEntry = 
        {
            attributes: cancelObj
        }
  
        cancelList.push(newCancelEntry);
      });
  
      let callType = isUpdate ? 'updateFeatures' : 'addFeatures'
      let featureUrl = `${rootServiceUrl}/${
        layerID
      }/${callType}`;

      let newLogs = [];
      cancelList.forEach((log) => {
        const newFeature = {
          attributes: log.attributes,
        };
        newLogs.push(newFeature);
      });
      const numberToTakeEachTime = 500;
      let startCount = 0;
      let hasMoreRecords = true;
      let finalResults = "";
      while (hasMoreRecords) {
        const numberToTake =
          startCount + numberToTakeEachTime > newLogs.length
            ? newLogs.length - startCount
            : numberToTakeEachTime;
        let numbersToRun = newLogs.slice(
          startCount,
          numberToTake + startCount
        );
        try {
          finalResults = await GeneralService.updateCallForMultiples(
            featureUrl,
            nifcToken,
            numbersToRun
          );
          if (finalResults && finalResults.updateResults) {
            allFinalResults.push(finalResults.updateResults);
          }
        } catch (e) {
          numbersToRun.forEach((item) => {
            const newItem = {
              objectId: item.attributes[FieldNames.featureFields.objectID],
              success: false,
            };
            allFinalResults.push(newItem);
          });
        }
        hasMoreRecords =
        newLogs.length > startCount + numberToTakeEachTime;
        startCount += numberToTakeEachTime;
      }
      let failedItems = [];
      let successfulItems = [];
      if (!hasMoreRecords) {
        allFinalResults.flat().forEach((result) => {
          if (result) {
            if (!result.success) {
              failedItems.push(result.objectId);
            } else {
              successfulItems.push(result.objectId);
            }
          }
        });
      }

      const allItemResults = {
        successful: successfulItems,
        failures: failedItems,
      };
      return allItemResults;
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getFeatureCancelReason: function(joinFeature, entityID) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const queryObject = new Query({
          where: `(JoinFeature = '${joinFeature}') AND (JoinID = ${entityID})`,
          orderByFields: "OBJECTID DESC",
          outFields: "*",
          returnGeometry: false,
          num: 1
      });
  
      let layerID = config.canceledFeatures[config.env].layerId;
  
      return query.executeQueryJSON(rootServiceUrl + "/" + layerID, queryObject).then(results => {
        let reasons = [];
        let firstReason = null;
        if(results.features) {
          reasons = results.features.map((eaItem) => {
            let retObj = {
              OBJECTID: eaItem.attributes[FieldNames.featureFields.objectID],
              EntityID: Number(eaItem.attributes[FieldNames.featureFields.entityID]),
              [FieldNames.cancelFields.joinID]: eaItem.attributes[FieldNames.cancelFields.joinID],
              [FieldNames.cancelFields.joinFeature]: eaItem[FieldNames.cancelFields.joinFeature],
              CancelReason: eaItem.attributes[FieldNames.cancelFields.cancelReason],
              CancelSubReason: eaItem.attributes[FieldNames.cancelFields.cancelSubReason]
            }
          return retObj;
          });
          firstReason = reasons[0];
        } 
        return (firstReason)
      })    
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getMultipleFeaturesCancelEntry: async function(joinFeature, entityIdList) {
    if(!entityIdList || entityIdList.length < 1)
    {
      return [];
    }

    const config = getAppConfig();
    const rootServiceUrl = getAttributeServiceUrl();
    let layerID = config.canceledFeatures[config.env].layerId;
    let allFinalResults = [];
    const numberToTakeEachTime = 2000;
    let startIndex = 0;
    let hasMoreRecords = true;
    let finalResults = "";
    while(hasMoreRecords){
      try{
        let endIndex = startIndex + numberToTakeEachTime;
        let entityIdBatch = [];
        entityIdBatch = entityIdList.slice(startIndex, endIndex);
        let entityIdBatchStr = entityIdBatch.join(",");
        let batchWhere = `((JoinFeature='${joinFeature}') AND (JoinID IN (` + entityIdBatchStr + ")))";

        const queryObject = new Query({
          where: batchWhere,
          orderByFields: "OBJECTID DESC",
          outFields: "*",
          returnGeometry: false,
          num:numberToTakeEachTime
        });
        finalResults = await GeneralService.queryCall(rootServiceUrl + "/" + layerID, queryObject);
        if(finalResults && finalResults.length > 0){
          allFinalResults.push(finalResults)
        }
      } catch(e){
        throw e;
      }
      hasMoreRecords = entityIdList.length > (startIndex + numberToTakeEachTime);
      startIndex += numberToTakeEachTime;
    }
    const allFinalResultsFlattened = (allFinalResults != null && allFinalResults.length > 0) ? allFinalResults.flat() : [];
    const allCarryoverEntries = allFinalResultsFlattened.map((r) => {
      let retObj = {
        CancelObjectID: r[FieldNames.featureFields.objectID],
        [FieldNames.cancelFields.joinID]: r[FieldNames.cancelFields.joinID],
        [FieldNames.cancelFields.joinFeature]: r[FieldNames.cancelFields.joinFeature],
        CancelReason: r[FieldNames.cancelFields.cancelReason],
        CancelSubReason: r[FieldNames.cancelFields.cancelSubReason]
      }
      return retObj;
    })
    return allCarryoverEntries;
  },
};

export default CancelService;